import { Hero } from '@/components/organisms/Admin/Mentors/Individual/Hero'

export function MentorsIndividualPage() {
	return (
		<>
			<Hero />
		</>
	)
}
